import { memo } from 'react';

import { Divider } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';

import { MenuModulesSubmenu } from 'components/header/menu-modules/desktop/MenuModulesSubmenu';
import { MenuModulesItem } from 'components/header/menu-modules/MenuModulesItem';
import { MenuNode } from 'components/header/menu-modules/types';

type MenuModulesNodeList = {
    nodes: MenuNode[];
    onClose(): void;
};

/**
 * Renderiza os menus conforme seu tipo:
 * Caso tenha filhos, exibe o item filho (menuSubmenu).
 * Caso não tenha, exibe o item (menuLeaf).
 */
export const MenuModulesNodeList = memo(function MenuModulesNodeList({ nodes, onClose }: MenuModulesNodeList) {
    let currentGroup: number | undefined = undefined;

    return (
        <>
            {nodes.map((node, index) => {
                const showSubmenu = node.children && node.children.length > 0;
                const showDivider = index > 0 && node.group !== undefined && node.group !== currentGroup;

                currentGroup = node.group;

                return (
                    <Fragment key={`${node.title}-${index}`}>
                        {showDivider && <Divider sx={{ margin: '0 !important' }} />}

                        {showSubmenu && <MenuModulesSubmenu node={node} onClose={onClose} />}

                        {!showSubmenu && <MenuModulesItem node={node} onClose={onClose} />}
                    </Fragment>
                );
            })}
        </>
    );
});
